<label class="relative inline-flex items-center cursor-pointer">
  <input 
    type="checkbox" 
    class="sr-only peer" 
    (change)="toggle()" 
    [checked]="isToggled" 
    [disabled]="isDisabled">
  
  <div 
    class="w-11 h-6 rounded-full transition"
    [ngClass]="{
      'bg-gray-300 peer-checked:bg-[#005FA8]': !isDisabled,
      'bg-gray-400': isDisabled
    }">
  </div>

  <div 
    class="absolute left-1 top-1 w-4 h-4 rounded-full transition-transform transform"
    [ngClass]="{
      'bg-white peer-checked:translate-x-5': !isDisabled,
      'bg-gray-200': isDisabled
    }">
  </div>
</label>
